<template>
    <div class="category">
        
        <div class="post--hero">
            <div class="post--hero--image"><img v-if="post.featuredMedia" :src="post.featuredMedia.src" /></div>
            <div class="post--hero--content">
                <b-container>
                    <div class="post--hero--wrapper">
                        <h3 class="post--hero--title">{{post.title}}</h3>
                        <!--<div class="post--hero--date">{{post.readableDate}}</div>-->
                        <div class="post--hero--cta">
                            <button-with-icon
                                variant="cta"
                                text="Torna indietro"
                                :icon="chevron_right"
                                :clicked="() => {
                                    router.go(-1)
                                }"
                            />
                        </div>
                    </div>
                </b-container>
            </div>
        </div>

        <b-container fluid>
            <div class="panel">
                <div class="post--content" v-html="post.content"></div>
                <stories-list
                    v-if="stories.length"
                    :stories="stories"
                    :category_code="category_code"
                    :show_cta="false"
                />
                <products-list
                    v-if="results.length"
                    :results="results"
                    :category_code="category_code"
                    :show_cta="false"
                    :mode="'list'"
                />  
            </div>          
        </b-container>
    </div>
</template>

<script>
    import Vue from 'vue'
    //import Slick from 'vue-slick'
    import { search, posts } from '@/api'
    import Router from '@/router'
    import Bwi from '@/components/atoms/button-with-icon'
    import { chevron_right } from '@/components/svg/chevrons'
    import ProductsList from '@/components/blocks/products-list'
    import StoriesList from '@/components/blocks/stories-list'
    export default {
        name: 'category',
        components: {
            //Slick
            'products-list': ProductsList,
            'stories-list': StoriesList,
            'button-with-icon': Bwi,
        },
        props: {
            category_code: String,
        },
        data() {
            return {
                categories: Vue.prototype.$config.livetravelCategories,
                post: {},
                stories: [],
                results: [],
            }
        },
        computed: {
        },
        created()
        {
            this.router = Router
            this.chevron_right = chevron_right
        },
        mounted() {
            (search)

            // carico contenuti pagina
            posts({
                postId: this.categories[this.category_code].postId,
                asArray: true,
            })
                .then(response => {
                    this.post = response.posts[0]
                })

            // carico stories
            posts({
                tag: this.categories[this.category_code].storiesTagId,
                asArray: true,
            })
                .then(response => {
                    this.stories = response.posts
                })

            search({
                categoryCode: this.category_code,
                asArray: true,
            })
                .then(response => {
                    this.results = response.results
                })
        },
        methods:{
        },
    }
</script>

<style lang="scss">
.category
{
    .panel
    {
        margin-bottom:$grid-gutter-width*2;
    }
}
</style>